import { ls, t } from '../i18n';
import { NOISE_REDUCTION_MODES, NOISE_REDUCTION_LABELS, type NoiseReduction } from '@reels/shared/audio';
import { Segmented } from './Controls';
export function AudioControls({ mode, onChange }: { mode: NoiseReduction; onChange: (mode: NoiseReduction) => void }) {
  return <div className="col">
    <Segmented ariaLabel={t('editor.sound.noise')} value={mode} onChange={onChange}
      options={NOISE_REDUCTION_MODES.map(value => ({ value, label: ls(NOISE_REDUCTION_LABELS[value]) }))} />
    <p className="muted small">{mode === 'off' ? t('editor.audio.off')
      : mode === 'strong' ? t('editor.audio.strong')
      : t('editor.audio.auto')}</p>
  </div>;
}
